import "reflect-metadata"; //needed for class-transformer
import "intersection-observer";
import "./elements/app";

const app = document.createElement("ptc-app");
document.body.appendChild(app);
